module.exports = __webpack_public_path__ + "static/image/font/pc/bmhannaair-3@3x.jpg?4ddf8ff7";